import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import Managers from '../../components/company/managers';

function AdminsSettings() {
    const { store, authStore } = useStores();

    const { currentCompany, addingManager, removingManagers, addManagerError } =
        store;

    const addManager = async (form) => {
        await store.addManagerToCurrentCompany(form.values());
    };

    const removeManager = async (companyId, email) => {
        await store.removeManagerFromCurrentCompany(email);
    };

    const sendLoginInfo = async (managerEmail) => {
        await authStore.signin(
            managerEmail,
            currentCompany.company_id,
            null,
            null,
            '/',
            'login-info'
        );
    };

    return (
        <Managers
            company={currentCompany}
            removingManagers={removingManagers}
            addingManager={addingManager}
            addManagerError={addManagerError}
            addManager={addManager}
            removeManager={removeManager}
            sendLoginInfo={sendLoginInfo}
        />
    );
}

export default observer(AdminsSettings);
